import { ROLES } from '../../../Data/SD';

export interface TrainingAuthorIdentity {
 currentUser?: {uid?:string}|null;
 currentUserInfo?: {organization?:{id?:number}}|null;
 currentRoles?: {name?:string}[]|null;
 currentOrganizationRoles?: {systemKey?:string}[]|null;
 currentOrganizationRolePolicies?: {policyPermission?:{permissionKey?:string}|null;policyPermissionScope?:{scope?:string}|null}[]|null;
 impersonatedUserId?:string|null;
}

/** Navigation hint only. Every authoring request is independently authorized by the API. */
export function trainingAuthorAccess(auth:TrainingAuthorIdentity) {
 const signedIn=!!auth.currentUser&&!auth.impersonatedUserId;
 const platformAuthor=signedIn&&!!auth.currentRoles?.some(role=>role.name===ROLES.SUPER_ADMIN);
 const organizationId=auth.currentUserInfo?.organization?.id;
 const inOrganization=Number.isInteger(organizationId)&&Number(organizationId)>0;
 const owner=!!auth.currentOrganizationRoles?.some(role=>role.systemKey==='ORG_OWNER');
 const explicit=!!auth.currentOrganizationRolePolicies?.some(policy=>policy.policyPermission?.permissionKey==='training:author'&&['all','organization','organization_wide'].includes(policy.policyPermissionScope?.scope||''));
 const canAuthorOrganization=signedIn&&inOrganization&&(owner||explicit);
 return {canAuthor:inOrganization&&(canAuthorOrganization||platformAuthor),canAuthorOrganization,canUsePlatformStudio:platformAuthor,organizationId};
}
